/**
 * Referral / Invite & Earn API
 * Endpoints: /api/referral/*
 */
import apiClient, { createAuthConfig, isMockApi } from "../client";
import {
  MOCK_REFERRAL_INVITES,
  MOCK_REFERRAL_ME,
} from "../../../pages/invite/inviteMockData";
import { getInviterPercent } from "../../../config/app/referral";

const REF_STORAGE_KEY = "ls_referral_code";

/** Persist invite code from ?ref= for later signup sync. */
export function captureReferralFromSearch(search = window.location.search) {
  try {
    const params = new URLSearchParams(search);
    const code = (params.get("ref") || params.get("referral") || "").trim();
    if (!code) return null;
    window.localStorage.setItem(REF_STORAGE_KEY, code.toUpperCase());
    return code.toUpperCase();
  } catch {
    return null;
  }
}

export function getStoredReferralCode() {
  try {
    return (window.localStorage.getItem(REF_STORAGE_KEY) || "").trim() || null;
  } catch {
    return null;
  }
}

export function clearStoredReferralCode() {
  try {
    window.localStorage.removeItem(REF_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

function mockDashboard() {
  const me = MOCK_REFERRAL_ME;
  return {
    success: true,
    referral_code: me.referral_code,
    invite_url: `https://lazystudio.ai/?ref=${me.referral_code}`,
    plan_key: me.plan_key,
    inviter_percent: getInviterPercent(me.plan_key),
    friend_bonus_percent: 20,
    rates_by_plan: { free: 10, lite: 15, pro: 20, max: 25 },
    stats: {
      invited: me.stats.invited,
      signed_up: me.stats.signed_up,
      welcome_claimed: me.stats.welcome_claimed,
      subscribed: me.stats.subscribed,
      rewarded: me.stats.rewarded,
      credits_lifetime: me.stats.credits_lifetime,
      credits_year: me.stats.credits_year,
      credits_month: me.stats.credits_month,
    },
    invites: MOCK_REFERRAL_INVITES,
  };
}

/**
 * @param {string} token
 */
export async function getReferralMe(token) {
  if (isMockApi) return mockDashboard();
  const response = await apiClient.get(
    "/api/referral/me",
    createAuthConfig(token)
  );
  return response.data;
}

/**
 * Fallback attribution if sync did not send the code.
 * @param {string} token
 * @param {string} referralCode
 */
export async function attributeReferral(token, referralCode) {
  if (isMockApi) return { success: true, ok: true };
  const response = await apiClient.post(
    "/api/referral/attribute",
    { referral_code: referralCode },
    createAuthConfig(token)
  );
  return response.data;
}

export default {
  getReferralMe,
  attributeReferral,
  captureReferralFromSearch,
  getStoredReferralCode,
  clearStoredReferralCode,
};
